import * as React from "react";

function SvgLightbulb(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 23.97"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M16.03 7.01a6 6 0 01-1.61 4.18c-.47.51-.85 1-1.16 1.36a9.68 9.68 0 00-.96 1.46 4.46 4.46 0 00-.53 1.68 1.4 1.4 0 01.73 1.32 1.43 1.43 0 01-.39 1 1.48 1.48 0 01-.31 2.26 1.54 1.54 0 01.23.74 1.33 1.33 0 01-.49 1.11 1.89 1.89 0 01-1.21.39 2.58 2.58 0 01-.94 1.1 2.51 2.51 0 01-2.72 0 2.64 2.64 0 01-.94-1.1 1.91 1.91 0 01-1.21-.39 1.33 1.33 0 01-.49-1.11 1.54 1.54 0 01.2-.73 1.43 1.43 0 01-.73-1.27 1.41 1.41 0 01.39-1 1.43 1.43 0 01-.39-1 1.41 1.41 0 01.74-1.28 4.49 4.49 0 00-.54-1.72 9.68 9.68 0 00-.93-1.49c-.3-.39-.69-.85-1.16-1.36A6 6 0 01.03 7.01a6.07 6.07 0 01.67-2.9A6.57 6.57 0 012.52 1.9 9.09 9.09 0 015.09.51a8.58 8.58 0 012.94-.5 8.68 8.68 0 012.89.5 9.17 9.17 0 012.56 1.39 6.71 6.71 0 011.83 2.21 6.18 6.18 0 01.72 2.9zm-2 0a4.23 4.23 0 00-.54-2.09 4.75 4.75 0 00-1.46-1.6 7.13 7.13 0 00-1.93-1 6.66 6.66 0 00-4.26 0 7.07 7.07 0 00-1.92 1A4.67 4.67 0 002.54 4.9a4.28 4.28 0 00.49 4.9l.48.52.48.51a8.61 8.61 0 012.2 4.65h3.59a8.56 8.56 0 012.25-4.65l.47-.51.48-.52a4.17 4.17 0 001.05-2.79zm-2.5 0a.51.51 0 01-.5.5.49.49 0 01-.35-.15.47.47 0 01-.18-.35 1.22 1.22 0 00-.84-1.11 4 4 0 00-1.63-.41.49.49 0 01-.35-.15.45.45 0 01-.18-.33.51.51 0 01.5-.5 5.3 5.3 0 011.56.25 3.43 3.43 0 011.36.85 1.91 1.91 0 01.58 1.4z" />
    </svg>
  );
}

const MemoSvgLightbulb = React.memo(SvgLightbulb);
export default MemoSvgLightbulb;
